import { makeStyles, fade } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    minHeight: theme.spacing(6),
    transition: theme.transitions.create(),
    '&:hover': {
      backgroundColor: theme.palette.custom.surface[1],
    },

    '& .list-courses-item': {
      '&-link': {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
      },
      '&-icon': {
        width: theme.spacing(4),
        height: theme.spacing(4),
        minWidth: theme.spacing(4),
        minHeight: theme.spacing(4),
        background: theme.palette.custom.surface[2],
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: theme.spacing(0, 1),
        color: theme.palette.text.hint,
        overflow: 'hidden',

        '& img': {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        },
      },
      '&-text': {
        margin: theme.spacing(0, 1),
        color: theme.palette.text.secondary,
        flexGrow: 1,
      },
      '&-lock': {
        color: theme.palette.text.hint,
      },
    },

    '&.locked': {
      '& .list-courses-item': {
        '&-text': {
          color: theme.palette.text.hint,
        },
        '&-icon, &-lock': {
          color: theme.palette.text.disabled,
        },
      },
    },
  },

  listItemSelected: {
    '&, &:hover': {
      backgroundColor: [fade(theme.palette.primary.main, 0.12), '!important'],
      '& .list-courses-item': {
        '&-text': {
          color: [theme.palette.primary.main, '!important'],
        },
        '&-icon': {
          backgroundColor: [theme.palette.primary.main, '!important'],
          color: [theme.palette.primary.contrastText, '!important'],
        },
      },
    },
  },
}));

export default styles;
